(function($){

    // parallax des bannière
    $('.with-parallax').each(function(){
        $(this).children('img').parallax($(this),4,-1);
    });

    // parallax de la bannière générale
    if($('.banner-parallax').length){
        $('.banner-parallax img').parallax($('.banner'),4,-1);
   }

   $(window).on('load scroll', function(){
        var y = $(this).scrollTop();//la distance de scroll
        var offset = 100;
        var body = $('body');

        if(y >= offset)  {
            if(!body.hasClass('sticky')){
                body.addClass('sticky');
            }
        }else {
            if(body.hasClass('sticky')){
                body.removeClass('sticky');
            }
        }
    });

    if($('.img-scroll-to').length){
		$('.img-scroll-to').click(function(){
            var whereToScroll = $(this).parents('.wp-block-cover').next();
			$('html, body').animate({
				scrollTop: whereToScroll.offset().top - 80
			}, 500, "linear");
		});
	}


    if($('.bloc-faq').length){
        $('.question-faq').click(function(){
            var contentHideWrapper = $(this).parents('.element-wrapper');
            var contentToShow = contentHideWrapper.find('.open-wrapper');
    
            if (contentHideWrapper.hasClass('open')) {
                contentHideWrapper.removeClass('open');
                contentToShow.slideUp( 500);
            } else {
                contentHideWrapper.addClass('open');
                contentToShow.slideDown(500);
            }
        });
    }
 

})(jQuery);